// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3q3dG","checkboxCol":"Table_checkboxCol__2Ya48","emailCol":"Table_emailCol__2grWO","actionCol":"Table_actionCol__1JMNq"};